import Button      from '@widesk-ui/components/Button';
import View        from '@widesk-ui/components/View';
import { ZoomInOutlined }  from '@ant-design/icons';
import { ZoomOutOutlined } from '@ant-design/icons';
import { ExpandOutlined }  from '@ant-design/icons';

type ControlsProps = {
	zoomPercent: number;
	onZoomIn: () => void;
	onZoomOut: () => void;
	onFit: () => void;
};

const PlanZoomControls = ({ zoomPercent, onZoomIn, onZoomOut, onFit }: ControlsProps) => (
	<View
		row
		gap={4}
		style={{
			position: 'absolute',
			top: 12,
			right: 12,
			alignItems: 'center',
			background: 'rgba(255,255,255,.95)',
			padding: 4,
			borderRadius: 6,
			border: '1px solid #eee',
		}}
	>
		<Button size="small" icon={<ZoomOutOutlined />} title="Dézoomer" onClick={onZoomOut} />
		<View size={12} color="#666" style={{ minWidth: 44, textAlign: 'center' }}>{zoomPercent} %</View>
		<Button size="small" icon={<ZoomInOutlined />} title="Zoomer" onClick={onZoomIn} />
		<Button size="small" icon={<ExpandOutlined />} title="Recadrer" onClick={onFit} />
	</View>
);

export default PlanZoomControls;
